import { render } from "./IconLibrary.vue?vue&type=template&id=3a66b911"
const script = {}

import "./IconLibrary.vue?vue&type=style&index=0&id=3a66b911&lang=css"

import exportComponent from "C:\\Users\\berge\\Desktop\\My Projects\\o2p-shop-planner\\SP.App\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__